var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdminTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20324 4.50149C5.61665 4.47565 5.97273 4.78983 5.99856 5.20324L6.93606 20.2032C6.93624 20.206 6.9364 20.2088 6.93654 20.2115C6.96247 20.7163 7.29759 21 7.68753 21H16.3125C16.6986 21 17.0322 20.7226 17.0639 20.2043L18.0015 5.20324C18.0273 4.78983 18.3834 4.47565 18.7968 4.50149C19.2102 4.52732 19.5244 4.8834 19.4986 5.29681L18.5611 20.2958C18.5611 20.2958 18.5611 20.2959 18.5611 20.2959C18.4868 21.5109 17.583 22.5 16.3125 22.5H7.68753C6.429 22.5 5.5039 21.5196 5.43875 20.293L4.50149 5.29681C4.47565 4.8834 4.78983 4.52732 5.20324 4.50149Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25C21 5.66421 20.6642 6 20.25 6H3.75C3.33579 6 3 5.66421 3 5.25Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1228 3C10.0738 2.99986 10.0253 3.0094 9.97997 3.02809C9.93468 3.04677 9.89352 3.07423 9.85887 3.10887C9.82423 3.14352 9.79677 3.18468 9.77809 3.22997C9.7594 3.27527 9.74986 3.32381 9.75 3.37281L9.75 3.375V5.25C9.75 5.66422 9.41422 6 9 6C8.58579 6 8.25 5.66422 8.25 5.25V3.37596C8.24945 3.12966 8.2975 2.88567 8.39143 2.65798C8.48551 2.4299 8.62376 2.22267 8.79821 2.04821C8.97267 1.87376 9.1799 1.73551 9.40798 1.64143C9.63567 1.5475 9.87966 1.49945 10.126 1.5H13.874C14.1203 1.49945 14.3643 1.5475 14.592 1.64143C14.8201 1.73551 15.0273 1.87375 15.2018 2.04821C15.3763 2.22267 15.5145 2.4299 15.6086 2.65798C15.7025 2.88572 15.7506 3.12976 15.75 3.37612V5.25C15.75 5.66422 15.4142 6 15 6C14.5858 6 14.25 5.66422 14.25 5.25V3.375L14.25 3.37281C14.2502 3.32381 14.2406 3.27527 14.2219 3.22997C14.2032 3.18467 14.1758 3.14352 14.1411 3.10887C14.1065 3.07423 14.0653 3.04677 14.02 3.02809C13.9747 3.0094 13.9262 2.99986 13.8772 3L13.875 3H10.125L10.1228 3Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5C12.4142 7.5 12.75 7.83579 12.75 8.25V18.75C12.75 19.1642 12.4142 19.5 12 19.5C11.5858 19.5 11.25 19.1642 11.25 18.75V8.25C11.25 7.83579 11.5858 7.5 12 7.5Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59824 7.50049C9.01219 7.4857 9.35975 7.80929 9.37453 8.22324L9.74953 18.7232C9.76432 19.1372 9.44073 19.4847 9.02678 19.4995C8.61283 19.5143 8.26527 19.1907 8.25049 18.7768L7.87549 8.27678C7.8607 7.86283 8.18429 7.51527 8.59824 7.50049Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4018 7.50049C15.8157 7.51527 16.1393 7.86283 16.1245 8.27678L15.7495 18.7768C15.7347 19.1907 15.3872 19.5143 14.9732 19.4995C14.5593 19.4847 14.2357 19.1372 14.2505 18.7232L14.6255 8.22324C14.6403 7.80929 14.9878 7.4857 15.4018 7.50049Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminTrash);
export default __webpack_public_path__ + "static/media/ic_admin_trash.f1f43635646fc8f6d4259090662d02a9.svg";
export { ForwardRef as ReactComponent };